<template>
  <div class="q-pa-sm full-height site-group-list ">
    <div class="full-height scroll">
      <rs-classify namespace="siteGroup" :treeConf="{ expandAll: false, selectFirst: false }">
        <template>
          <rs-field name="id" />
          <rs-field name="name" />
          <rs-field name="type" />
        </template>
        <!-- <template slot="rootForm">
        <rs-field name="name" />
      </template> -->
      </rs-classify>
    </div>
  </div>
</template>
<script>
import RsClassify from "rsui-core/src/core/components/classify/classify.vue";
export default {
  components: { RsClassify },
  data: function() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
